package org.dronda.lib.validation

import com.github.michaelbull.result.Err
import com.github.michaelbull.result.Ok
import com.github.michaelbull.result.Result
import com.github.michaelbull.result.getError
import com.github.michaelbull.result.getOrThrow

fun <T, R, E> collect(results: List<Result<T, E>>, collector: (List<T>) -> R): Result<R, List<E>> {
    val errors = results.mapNotNull { it.getError() }
    return if (errors.isEmpty()) {
        val successes = results.map { it.getOrThrow { IllegalStateException("Logically shouldn't be thrown") } }
        Ok(collector(successes))
    } else {
        Err(errors)
    }
}



fun <T0, T1, SUCCESS, ERROR> collect(
    a0: Result<T0, ERROR>,
    a1: Result<T1, ERROR>,
    collector: (T0, T1) -> SUCCESS
): Result<SUCCESS, List<ERROR>> =
    collect(listOf(a0, a1)) { list ->
        @Suppress("UNCHECKED_CAST")
        collector(list[0] as T0, list[1] as T1)
    }

fun <T0, T1, T2, SUCCESS, ERROR> collect(
    a0: Result<T0, ERROR>,
    a1: Result<T1, ERROR>,
    a2: Result<T2, ERROR>,
    collector: (T0, T1, T2) -> SUCCESS
): Result<SUCCESS, List<ERROR>> =
    collect(listOf(a0, a1, a2)) { list ->
        @Suppress("UNCHECKED_CAST")
        collector(list[0] as T0, list[1] as T1, list[2] as T2)
    }

fun <T0, T1, T2, T3, SUCCESS, ERROR> collect(
    a0: Result<T0, ERROR>,
    a1: Result<T1, ERROR>,
    a2: Result<T2, ERROR>,
    a3: Result<T3, ERROR>,
    collector: (T0, T1, T2, T3) -> SUCCESS
): Result<SUCCESS, List<ERROR>> =
    collect(listOf(a0, a1, a2, a3)) { list ->
        @Suppress("UNCHECKED_CAST")
        collector(list[0] as T0, list[1] as T1, list[2] as T2, list[3] as T3)
    }

fun <T0, T1, T2, T3, T4, SUCCESS, ERROR> collect(
    a0: Result<T0, ERROR>,
    a1: Result<T1, ERROR>,
    a2: Result<T2, ERROR>,
    a3: Result<T3, ERROR>,
    a4: Result<T4, ERROR>,
    collector: (T0, T1, T2, T3, T4) -> SUCCESS
): Result<SUCCESS, List<ERROR>> =
    collect(listOf(a0, a1, a2, a3, a4)) { list ->
        @Suppress("UNCHECKED_CAST")
        collector(list[0] as T0, list[1] as T1, list[2] as T2, list[3] as T3, list[4] as T4)
    }

